import { ACHProcessorData } from "globalConstants";

import { createCustomEnum } from "../customEnum";

const WhoAreYourCustomersTypes = createCustomEnum({
	Individuals: {
		value: ACHProcessorData.CustomerType.Individuals.value,
		name: ACHProcessorData.CustomerType.Individuals.value,
		displayName: ACHProcessorData.CustomerType.Individuals.displayName,
	},
	Businesses: {
		value: ACHProcessorData.CustomerType.Businesses.value,
		name: ACHProcessorData.CustomerType.Businesses.value,
		displayName: ACHProcessorData.CustomerType.Businesses.displayName,
	},
	Both: {
		value: ACHProcessorData.CustomerType.Both.value,
		name: ACHProcessorData.CustomerType.Both.value,
		displayName: ACHProcessorData.CustomerType.Both.displayName,
	},
});

export default WhoAreYourCustomersTypes;
